import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo-dark.svg'


const _hoisted_1 = { class: "sticky top-0 z-20 w-full h-[72px] bg-primary-gray text-white flex items-center justify-center px-4" }
const _hoisted_2 = { class: "max-w-[1120px] w-full flex md:gap-4 lg:gap-6 items-center h-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo",
    class: "-mt-2 cursor-pointer hover:scale-110 transition-all"
  })
], -1)
const _hoisted_4 = { class: "flex items-center gap-3 lg:gap-5 h-full" }

import DefaultButton from "@/components/common/default-button.vue";
import NavItem from "@/components/navigation/nav-item.vue";
import { getCurrentPath } from "@/router/local-router";
import { computed, onMounted, onUnmounted, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'header-lg',
  setup(__props) {

const scrollPos = ref(window.scrollY);

const handleScroll = () => {
  scrollPos.value = window.scrollY;
};

onUnmounted(() => {
  if (window) {
    window.removeEventListener("scroll", handleScroll);
  }
});
const buttonText = computed(() => {
  if (scrollPos.value < 700) {
    return "Request a Quote";
  } else {
    return "Contact Us";
  }
});
const currentPath = ref(getCurrentPath());
const updatePath = () => {
  currentPath.value = getCurrentPath();
};

onMounted(() => {
  if (window) {
    window.addEventListener("scroll", handleScroll);
  }
  window.addEventListener("pathchange", updatePath);
});
const onReuestQuote = () => {
  document
    .getElementById("quote-div")
    ?.scrollIntoView({ behavior: "smooth", block: "center" });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(NavItem, {
          href: "#family-space",
          class: _normalizeClass(["border-b-[6px] pt-1.5", {
            'border-light-green': currentPath.value === 'family-space',
            'border-transparent': currentPath.value !== 'family-space',
          }])
        }, {
          default: _withCtx(() => [
            _createTextVNode("Family Space")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(NavItem, {
          href: "#commercial",
          class: _normalizeClass(["border-b-[6px] pt-1.5", {
            'border-light-green': currentPath.value === 'commercial',
            ' border-transparent': currentPath.value !== 'commercial',
          }])
        }, {
          default: _withCtx(() => [
            _createTextVNode("Commerical")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(NavItem, {
          href: "#putting-greens",
          class: _normalizeClass(["border-b-[6px] pt-1.5", {
            'border-light-green': currentPath.value === 'putting-greens',
            'border-transparent': currentPath.value !== 'putting-greens',
          }])
        }, {
          default: _withCtx(() => [
            _createTextVNode("Putting Greens")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(NavItem, {
          href: "#happy-pets",
          class: _normalizeClass(["border-b-[6px] pt-1.5", {
            'border-light-green': currentPath.value === 'happy-pets',
            'border-transparent': currentPath.value !== 'happy-pets',
          }])
        }, {
          default: _withCtx(() => [
            _createTextVNode("Happy Pets")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(NavItem, {
          href: "#lighting",
          class: _normalizeClass(["border-b-[6px] pt-1.5", {
            'border-light-green': currentPath.value === 'lighting',
            'border-transparent': currentPath.value !== 'lighting',
          }])
        }, {
          default: _withCtx(() => [
            _createTextVNode("Lighting")
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createVNode(DefaultButton, {
        class: "ml-auto transition-all md:px-2",
        onClick: onReuestQuote
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(buttonText.value), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})